module.exports = __webpack_public_path__ + "8017491e5b4fa2b042d32aae7438aaa7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-32.png
// module id = 1682
// module chunks = 0